import { DatePicker, LocalizationProvider, TimePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { Autocomplete, Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react'
import AddIcon from "@mui/icons-material/Add";
import { useHistory } from 'react-router';
import { useState } from 'react';
import { useEffect } from 'react';
import api from '../../../components/services/api'
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
export default function Add_EIR() {
  const history = useHistory();
  const [rows, setRows] = useState([]);
  const [rowsFilter, setRowsFilter] = useState([]);
  const [data, setData] = useState([])
  const [type, setType] = useState('')
  const [value, setValue] = React.useState(null);
  const [selected, setSelected] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [truck, setTruck] = useState('')
  const [truckCompany, setTruckCompany] = useState('')
  const [liners, setLiners] = useState([])

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deletehand = (i) => {

    const data = rows?.filter((e) => i?.id !== e?.id);
    setRows(data);
    const row = rowsFilter.map((x) => {
      x.check = i?.ContainerDetail.filter((y) => y.ContainerNo === x.ContainerNo)?.map(u => u.ContainerNo === u.ContainerNo)[0] ? false : x?.check
      return x
    })
    setRowsFilter(row)
  };
  useEffect(() => {
    const getStuffingPlan = async () => {
      const res = await api.get(`api/eir/stuffingPlan/list?eirType=${type}`)
      const data = await res.data
      setData(data)
    }
    getStuffingPlan()
  }, [type])
  const getLiners = async () => {
    try {
      const res = await api.get("api/liners/list");
      const data = await res.data
      if (res.meta.status === true) {
        setLiners(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getLiners()
  }, [])


  const handleSubmit = () => {
    const body = {
      EIRType: type,
      SaleOrderId: value?.SaleOrderId,
      SaleOrderNo: value?.SaleOrderNo,
      BookingNo: value?.BookingNo,
      CustomerId: value?.CustomerId,
      CustomerName: value?.CustomerName,
      FactoryId: value?.FactoryId,
      FactoryName: value?.FactoryName,
      FactoryAddress: value?.FactoryAddress,
      FactoryTel: value?.FactoryTel,
      EIRDate: value?.EIRDate,
      EIRTime: value?.EIRTime,
      ShipperRefNo: value?.ShipperRefNo,
      ShipperLineId: value?.ShipperLineId,
      CustomGate: value?.CustomGate,
      Size: value?.Size,
      GroupShipmentId: value?.GroupShipmentId,
      TugId: value?.TugId,
      TugName: value?.TugName,
      BargeId: value?.BargeId,
      BargeName: value?.BargeName,
      VoyNo: value?.VoyNo,
      TruckDetail: rows
    }
    const postData = async () => {
      const res = await api.post(`api/eir/create`, body)
      const data = await res.data
      if (res.meta.status) {
        Swal.fire({
          title: `${res.meta.message}`,
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            console.log('first')
          }
        })
      }
    }
    postData()
  }

    const columns = [
      {
        field: "ContainerNo",
        headerName: "ContainerNo",

        width: 150,
      },
      {
        field: "ContainerGender",
        headerName: "ContainerGender",

        width: 150,
      },
      {
        field: "Seal",
        headerName: "Seal",

        width: 150,
      },
      {
        field: "Seal_1",
        headerName: "Seal_1",

        width: 150,
      },
      {
        field: "Seal_2",
        headerName: "Seal_2",

        width: 150,
      },
      {
        field: "TareWeight",
        headerName: "TareWeight",

        width: 80,
      },
      {
        field: "VGMWeight",
        headerName: "VGMWeight",

        width: 80,
      },
      {
        field: "CargoWeight",
        headerName: "CargoWeight",

        width: 80,
      },
      {
        field: "ContainerStatus",
        headerName: "ContainerStatus",

        width: 80,
      },
    ]
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            EIR
          </h6>

          <Grid container alignItems="center" spacing={1} sx={{ justifyContent: 'space-between' }}>
            <Grid item >
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Equipment Interchange Receipt
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">
                Truck{" "}
              </Typography>
              <Typography>
                <span>&nbsp;</span> / AddEIR
              </Typography>
            </Grid>
          </Grid>

          <Grid
            //   container
            //   sx={{ justifyContent: "end" }}
            style={{ marginTop: "10px", display: "flex", flexDirection: "row", justifyContent: 'space-between' }}
          >
            <Box
              sx={{
                width: "100%",
                marginTop: "10px",
                paddingBottom: "24px",
              }}
            >
              <Grid container>
                <Grid xs={4} sx={{ marginRight: "15px" }}>
                  <FormControl sx={{
                    width: "100%", marginRight: '10px',
                  }}>
                    <InputLabel>EIR Type</InputLabel>
                    <Select
                      label="EIR Type"
                      value={type}
                      // InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        setType(e.target.value)
                      }}
                    // disabled={values.liners !== ""}
                    >
                      <MenuItem
                        value={'ToFactory'}
                      >
                        ToFactory
                      </MenuItem>
                      <MenuItem
                        value={'FromFactory'}
                      >
                        FromFactory
                      </MenuItem>
                      <MenuItem
                        value={'Other'}
                      >
                        Other
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid xs={4} sx={{ marginRight: "15px" }}></Grid>


                <Grid xs={4} sx={{ marginRight: "15px" }}>
                  <Autocomplete
                    options={data}
                    getOptionLabel={(option) => option?.SaleOrderNo}
                    id="controlled-demo"
                    value={value}
                    onChange={(event, newValue) => {
                      setValue(newValue);
                      setRowsFilter(newValue?.Container)
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="SaleOrder." style={{
                        width: "100%",
                        marginTop: "10px",
                      }} variant="outlined" />
                    )}
                  />
                </Grid>
                <Grid xs={4} sx={{ marginRight: "15px" }}>
                  <Autocomplete
                    options={data}
                    getOptionLabel={(option) => option?.BookingNo}
                    id="controlled-demo"
                    value={value}
                    onChange={(event, newValue) => {
                      setValue(newValue);
                      setRowsFilter(newValue?.Container)
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="BookingNo." style={{
                        width: "100%",
                        marginTop: "10px",
                      }} variant="outlined" />
                    )}
                  />
                </Grid>
                <Grid xs={4} sx={{ marginRight: "15px" }}>
                  <TextField
                    disabled
                    label="Customer Name"
                    value={value?.CustomerName}
                    variant="outlined"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid xs={4} sx={{ marginRight: "15px" }}>
                  <TextField
                    label="Factory Name."
                    value={value?.FactoryName}
                    variant="outlined"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      // backgroundColor: "#EAECEF",
                    }}
                    disabled
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid xs={4} sx={{ marginRight: "15px" }}>
                  <TextField
                    disabled
                    label="Factory Address"
                    value={value?.FactoryAddress}
                    variant="outlined"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      // backgroundColor: "#EAECEF",
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid xs={4} sx={{ marginRight: "15px" }}>
                  <TextField
                    disabled
                    label="Tel."
                    value={value?.FactoryTel}
                    variant="outlined"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      // backgroundColor: "#EAECEF",
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid xs={4} sx={{ marginRight: "10px" }}>
                  <DatePicker
                    disabled
                    inputFormat="dd/MM/yyyy"
                    name="date"
                    value={value?.EIRDate}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Date"
                        style={{
                          marginTop: "10px",

                          width: "100%",
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid xs={4} >
                  <TimePicker
                    disabled
                    label="Time"
                    value={value?.EIRTime}

                    renderInput={(params) => (
                      <TextField
                        style={{
                          width: "100%",
                          marginTop: "10px",

                        }}
                        {...params}
                      />
                    )}
                  />
                </Grid>


              </Grid>
              <Button
                type="button"
                variant="contained"
                // disabled={costType ? false : true}
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginTop: "10px",
                }}
                onClick={handleClickOpen}
              >
                <AddIcon /> Add EIR
              </Button>
              <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                <Table stickyHeader>
                  <TableRow>
                    <TableCell align="center" width="5%">#</TableCell>
                    <TableCell align="center" width="15%">TRUCK COMPANY</TableCell>
                    <TableCell align="center" width="10%">TRUCK No.</TableCell>
                    <TableCell align="center" width="70%">Container</TableCell>
                    {/* <TableCell align="center" width="15%">Seal NO</TableCell>
                  <TableCell align="center" width="10%">NET WEIIGHT (KGS)</TableCell>
                  <TableCell align="center" width="10%">STATUS CTRN</TableCell> */}
                    {/* <TableCell align="center" width="15%">Total(THB)</TableCell> */}
                    <TableCell align="center" width="10%"></TableCell>
                  </TableRow>

                  {rows?.map((data, index) => {
                    return (
                      <TableBody key={index}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">
                          {data?.TruckCompany}
                        </TableCell>
                        <TableCell align="center">
                          {data?.TruckNo}
                        </TableCell>
                        <TableCell align="center" padding='none'>
                          <TableRow>
                            <TableCell align="center" width="15%">Container No.</TableCell>
                            <TableCell align="center" width="15%">Seal </TableCell>
                            <TableCell align="center" width="15%">Seal 1</TableCell>
                            <TableCell align="center" width="15%">Seal 2</TableCell>
                            <TableCell align="center" width="10%">TareWeight</TableCell>
                            <TableCell align="center" width="10%">CargoWeight</TableCell>
                            <TableCell align="center" width="10%">VGMWeight</TableCell>
                            <TableCell align="center" width="10%">STATUS</TableCell>
                          </TableRow>
                          {data?.ContainerDetail?.map((y) => (
                            <TableRow>
                              <TableCell>{y?.ContainerNo}</TableCell>
                              <TableCell>{y?.Seal}</TableCell>
                              <TableCell>{y?.Seal_1}</TableCell>
                              <TableCell>{y?.Seal_2}</TableCell>
                              <TableCell>{y?.TareWeight}</TableCell>
                              <TableCell>{y?.CargoWeight}</TableCell>
                              <TableCell>{y?.VGMWeight}</TableCell>
                              <TableCell>{y?.ContainerStatus}</TableCell>
                            </TableRow>
                          ))}

                        </TableCell>


                        <TableCell align="center">
                          <Button
                            type="button"
                            variant="outlined"
                            style={{
                              color: "#80c340",
                              borderColor: "#80c340",
                            }}
                            onClick={() => deletehand(data)}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableBody>
                    );
                  })}
                  {console.log(rows)
                  }
                </Table>
              </TableContainer>
              <Box sx={{ display: 'flex', marginTop: '100px' }}>
                <Box sx={{ display: 'flex' }}>
                  <Button
                    type="button"
                    variant="outlined"
                    style={{
                      color: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    onClick={history.goBack}
                  >
                    back
                  </Button>
                  <Button
                    // type="submit"
                    disabled={type && value && rows.length > 0 ? false : true}
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    onClick={handleSubmit}
                  >
                    {/* {isSubmitting && <CircularProgress size={22} />}
                  {!isSubmitting && "SAVE"} */}
                    SAVE
                  </Button>
                </Box>
              </Box>
              <Dialog
                maxWidth='lg'
                fullWidth
                open={open}
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle>{"Use Google's location service?"}</DialogTitle>
                <DialogContent>
                  <Box sx={{ display: 'flex', marginTop: "10px", marginBottom: "20px" }}>
                    <FormControl
                      size='small'
                      sx={{ width: "100%", marginRight: '10px' }}

                    >
                      <InputLabel>TRUCK COMPANY</InputLabel>
                      <Select
                        label="TRUCK COMPANY "
                        value={truckCompany}
                        onChange={e => setTruckCompany(e.target.value)}
                      >
                        <MenuItem value="" disabled>
                          <em>เลือก TRUCK COMPANY</em>
                        </MenuItem>
                        {liners?.map((x) => (
                          <MenuItem value={x?.LinersName}>
                            {x?.LinersName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <TextField
                      size='small'
                      label="TRUCK No."
                      variant="outlined"
                      value={truck}
                      onChange={e => setTruck(e.target.value)}
                      style={{
                        width: "100%",

                        // backgroundColor: "#EAECEF",
                      }}
                      InputLabelProps={{ shrink: true }}

                    />
                  </Box>
                  <Box sx={{
                    height: '450px', '& > .MuiDataGrid-root .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
                      display: 'none'
                    }
                  }}>
                    <DataGrid
                      getRowId={(r) => r.ContainerNo || "0"}
                      rows={rowsFilter?.filter((x) => x.check !== true)}
                      columns={columns}
                      pageSize={6}
                      rowsPerPageOptions={[6]}
                      hideFooterSelectedRowCount
                      disableColumnFilter
                      disableColumnMenu
                      checkboxSelection
                      getCellClassName={(params) => {
                        if (params.field === "Status") {
                          return params.value == true ? "Active" : "Inactive";
                        }
                      }}
                      isRowSelectable={(params) => selected?.length <= 1 ? true : selected?.filter(y => y.ContainerNo === params.row.ContainerNo)?.map((x) => x?.ContainerNo === params.row.ContainerNo)[0]}
                      onSelectionModelChange={(ids) => {
                        const selectedIDs = new Set(ids);
                        const selectedRows = rowsFilter?.filter((row) =>
                          selectedIDs.has(row.ContainerNo)
                        );
                        setSelected(selectedRows);


                      }}
                    />
                  </Box>

                </DialogContent>
                <DialogActions>
                  <Button onClick={() => {
                    handleClose()
                    setSelected([])
                    setTruck('')
                    setTruckCompany('')
                  }}>Close</Button>
                  <Button disabled={selected.length > 0 && truck && truckCompany ? false : true} onClick={() => {
                    const row = {
                      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
                      TruckCompany: truckCompany,
                      TruckNo: truck,
                      ContainerDetail: selected
                    }
                    setRows([...rows, row])
                    if (selected.length > 0) {
                      const setCheckRow = rowsFilter?.map((x) => {
                        x.check = selected?.filter((y) => y.ContainerNo === x.ContainerNo)?.map(u => u.ContainerNo === u.ContainerNo)[0] ? true : x?.check
                        return x
                      })
                      setRowsFilter(setCheckRow)
                    }
                    setOpen(false)
                    setTruck('')
                    setTruckCompany('')
                  }}>Confirm</Button>
                </DialogActions>
              </Dialog>
            </Box>
          </Grid>
        </Card>
      </LocalizationProvider>
    )
  }
